<ng-container *ngComponentOutlet="spinnerComponent"></ng-container>
    